import * as React from 'react';
import styled from 'styled-components';

import { ISecondaryButtonProps, SecondaryButton } from '@longline/aqua-ui/controls/SecondaryButton/SecondaryButton';

const PaneFab = (props: ISecondaryButtonProps) => {
  return (
    <Holder>
      <SecondaryButton {...props}/>
    </Holder>
  )
}

const Holder = styled.div`
  // Position & size:
  position: absolute;
  right: 8px;
  bottom: 8px;
`

export { PaneFab }
